import { IListData, IListDataWithId } from './types';

export const defaultListDataWithId: IListDataWithId = {
  allList: [],
  list: [],
  selected: [],
  duplicate: null
};

export const defaultListData: IListData = {
  list: [],
  chosen: [],
  duplicate: null
};

export const distributionSettingsOptions = ['Show to all advisory firms', 'Restrict to selected advisory firms'];

export const yseNoOptions = ['Yes', 'No'];

export const DEFAULT_RESTRICTIONS_ERROR = 'At least one advisory firm must be selected';
